var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamChallengeLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 22.4995H3.75C1.88375 22.4995 0 21.082 0 17.917V11.617C0.0262839 8.7447 1.10178 5.98112 3.02397 3.84666C4.94616 1.7122 7.58239 0.354145 10.4362 0.0282297C12.0467 -0.0886775 13.6634 0.142457 15.1766 0.705926C16.6898 1.2694 18.064 2.152 19.2057 3.29375C20.3475 4.43551 21.2301 5.80967 21.7936 7.32285C22.357 8.83603 22.5882 10.4528 22.4712 12.0632C22.1449 14.9183 20.7857 17.5554 18.6497 19.4777C16.5138 21.4 13.7485 22.4748 10.875 22.4995ZM25 11.3495H24.985C24.985 11.6457 24.985 11.942 24.97 12.2395C24.4875 18.9995 18.3088 24.722 11.355 24.9757V24.9945C12.2308 26.5134 13.4905 27.7753 15.0078 28.6538C16.5251 29.5322 18.2467 29.9963 20 29.9995H26.25C27.2446 29.9995 28.1984 29.6044 28.9017 28.9011C29.6049 28.1979 30 27.244 30 26.2495V19.9995C29.9982 18.2459 29.5353 16.5235 28.6577 15.0053C27.7801 13.4871 26.5187 12.2263 25 11.3495Z",
    fill: "#6261AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamChallengeLoaderLogo);
export default __webpack_public_path__ + "static/media/TeamChallengeLoaderLogo.89a3b3ce6bd3b7a6426bc5446723d24f.svg";
export { ForwardRef as ReactComponent };